<template>
    <!-- New Navigation -->
    <!-- ====== Navbar Section Start -->
<nav id="topnav" class="fixed top-0 left-0 z-50 w-full bg-white shadow-md transition-all duration-300 py-4">
    <div class="container mx-auto px-4">
        <div class="flex items-center justify-between">
            <!-- Left Logo -->
            <div class="w-1/4 flex-shrink-0">
                <Link :href="route('home')">
                    <logo class="help-desk-logo h-12 md:h-16 w-auto" />
                </Link>
            </div>

            <!-- Center Title (Desktop) -->
            <div class="hidden md:flex flex-1 justify-center px-4">
                <h1 class="text-xl font-bold text-center md:text-2xl lg:text-3xl whitespace-nowrap">
                    Civil Aviation Authority of Zimbabwe
                </h1>
            </div>

            <!-- Mobile Title (Hidden on desktop) -->
            <div class="md:hidden flex-1 text-center px-2">
                <h1 class="text-sm font-bold sm:text-base line-clamp-2">
                    Civil Aviation<br>Authority of Zimbabwe
                </h1>
            </div>

            <!-- Right Logo -->
            <div class="w-1/4 flex-shrink-0 flex justify-end">
                <Link :href="route('home')">
                    <logo class="help-desk-logo h-12 md:h-16 w-auto" />
                </Link>
            </div>
        </div>
    </div>
</nav>
</template>
<script>
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import Icon from '@/Shared/Icon'
import { Link } from '@inertiajs/vue3'

export default {
  components: {
    Logo,
    Icon,
    Dropdown,
    Link
  },
  data() {
    return {
      active_menu: 'home',
      enable_option: {},
      isNavOpen: false
    }
  },
  computed: {
    selected_language() {
      return this.$page.props.languages.find(language =>
        language.code === this.$page.props.locale
      )
    },
    languages_except_selected() {
      return this.$page.props.languages.filter(language =>
        language.code !== this.$page.props.locale
      )
    }
  },
  methods: {
    toggleMenu() {
      const isToggle = document.getElementById('isToggle')
      const navigation = document.getElementById('navigation')

      if (isToggle) {
        isToggle.classList.toggle('open')
      }

      if (navigation) {
        navigation.style.display =
          navigation.style.display === "block" ? "none" : "block"
      }
    },
    windowScroll() {
      const navbar = document.getElementById("topnav")
      if (!navbar) return

      if (document.body.scrollTop >= 50 ||
          document.documentElement.scrollTop >= 50) {
        navbar.classList.add("sticky")
      } else {
        navbar.classList.remove("sticky")
      }
    },
    setupNavbarToggler() {
      const navbarToggler = document.getElementById('navbarToggler')
      const navbarCollapse = document.getElementById("navbarCollapse")

      if (navbarToggler && navbarCollapse) {
        navbarToggler.onclick = () => {
          navbarToggler.classList.toggle("navbarTogglerActive")
          navbarCollapse.classList.toggle("hidden")
          this.isNavOpen = !this.isNavOpen
        }
      }
    }
  },
  mounted() {
    this.active_menu = this.$page.url.substr(1) || 'home'

    if (this.$page.props.enable_options) {
      const options = JSON.parse(this.$page.props.enable_options.value)
      options.forEach(option => {
        this.enable_option[option.slug] = !!option.value
      })
    }

    window.addEventListener('scroll', this.windowScroll)
    this.setupNavbarToggler()
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.windowScroll)
  }
}</script>
